import { Grid } from "@material-ui/core";
import React, { forwardRef } from "react";
import { useDispatch } from "react-redux";

import { CARD_TYPES } from "features/planner/planner.constants";
import DummyCard from "features/planner/components/Card/DummyCard";
import { initializeEditCard } from "features/planner/planner.actions";
import EmployeeCard from "features/planner/components/Card/EmployeeCard/EmployeeCard";

const CardContent = forwardRef(({ card, cardId, groupId, isDragging }, ref) => {
  const dispatch = useDispatch();

  if (isDragging) return <Grid ref={ref} />;

  return (
    <Grid container ref={ref}>
      {card.get("type") === CARD_TYPES.DUMMY ? (
        <DummyCard
          card={card}
          cardId={cardId}
          groupId={groupId}
          initializeEditCard={() => dispatch(initializeEditCard(cardId))}
        />
      ) : (
        <EmployeeCard
          card={card}
          cardId={cardId}
          groupId={groupId}
          initializeEditCard={() => dispatch(initializeEditCard(cardId))}
        />
      )}
    </Grid>
  );
});
export default CardContent;
